import { useEffect, useState } from "react";
import { ref, onValue } from "firebase/database";
import type { IProduct } from "../types/types";
import { realtimeDb } from "../utils/firebase";

export function useProducts() {
  const [products, setProducts] = useState<IProduct[]>([]);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);

  const productsRef = ref(realtimeDb, "products");

  useEffect(() => {
    const unsubscribe = onValue(
      productsRef,
      snapshot => {
        const data: Record<string, IProduct> = snapshot.exists() ? snapshot.val() : {};
        setProducts(Object.entries(data).map(([key, p]) => ({ ...p, id: key })));
        setLoading(false);
      },
      err => {
        setError(err.message);
        setLoading(false);
      }
    );

    return () => unsubscribe();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return { products, loading, error };
}
